import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MltSearch from '@wix/da-ds/pkg/Icons/24x24/MltSearch';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { getDeviationResourceType, getIsPost } from '../../../DeviationViews/_helpers';
import { DeviationResourceType } from '../../../types/deviation';
import { AuthorWatchButton } from '../../../Button';
import { getBlockBI } from '../../helpers';
import SeeAllLink from '../SeeAllLink';
import MoreByAuthor from '../MoreByAuthor';
import ContentByUser from '../ContentByUser';
import OwnedByUser from '../OwnedByUser';
import s from './SidebarBlockWrapper.scss';
const SidebarBlockWrapper = ({ deviation, block: { contentTitleType, contentType, seeAllType = 'seeall', seeAllUrl, titleType = 'plaintext', linkUrl, deviations: blockDeviations }, children, className, headerClassName, titleClassName, seeAllClassName, onSeeAllClick })=>{
    var _firstBlockDeviation_adoptable, _deviation_author, _deviation_author1, _deviation_author2;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const showSeeAllLink = !!seeAllUrl || !!onSeeAllClick;
    const { author } = deviation;
    const resourceType = getDeviationResourceType(deviation);
    const { needsSubscription, isSubscribedButBlocked } = useSubscriptionTier(deviation);
    const currentUser = useCurrentUser();
    const isDisplayingAnotherUsersMoreBy = !showSeeAllLink && titleType === 'more-by' && author && (author === null || author === void 0 ? void 0 : author.userId) !== currentUser.userId;
    const seeAllAlwaysVisible = showSeeAllLink && titleType === 'plaintext' && seeAllUrl;
    // precondition: the owner is the same for all deviations in the block
    const [firstBlockDeviation] = blockDeviations || [];
    const owner = firstBlockDeviation === null || firstBlockDeviation === void 0 ? void 0 : (_firstBlockDeviation_adoptable = firstBlockDeviation.adoptable) === null || _firstBlockDeviation_adoptable === void 0 ? void 0 : _firstBlockDeviation_adoptable.owner;
    const isNotOwner = (owner === null || owner === void 0 ? void 0 : owner.userId) !== currentUser.userId;
    const emphasisOnOwner = contentType === 'owned_by' && owner;
    const isMlt = contentType === 'recommended' && resourceType === DeviationResourceType.ART && !getIsPost(deviation) && !(needsSubscription || isSubscribedButBlocked);
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: getBlockBI(contentType)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], seeAllAlwaysVisible && s['see-all-visible'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['block-header'], headerClassName)
    }, /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['block-title'], titleClassName)
    }, emphasisOnOwner ? /*#__PURE__*/ React.createElement(OwnedByUser, {
        owner: owner
    }) : titleType === 'more-by' && deviation.author ? /*#__PURE__*/ React.createElement(MoreByAuthor, {
        author: deviation.author,
        contentType: contentType
    }) : titleType === 'link' && linkUrl ? /*#__PURE__*/ React.createElement(ContentByUser, {
        contentTitle: t(`sidebar.blockTitle.${contentType}`, {
            author: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username
        }),
        contentUrl: linkUrl
    }) : isMlt ? t(`sidebar.blockTitle.${contentType}.mlt`) : t(`sidebar.blockTitle.${contentType}`, {
        author: (_deviation_author1 = deviation.author) === null || _deviation_author1 === void 0 ? void 0 : _deviation_author1.username
    })), showSeeAllLink && /*#__PURE__*/ React.createElement(SeeAllLink, {
        contentType: contentType,
        deviation: deviation,
        type: seeAllType,
        url: seeAllUrl,
        onClick: onSeeAllClick,
        className: classnames(s['see-all'], seeAllClassName)
    }), !isMobile && isDisplayingAnotherUsersMoreBy && /*#__PURE__*/ React.createElement(AuthorWatchButton, {
        className: s['watch-button'],
        author: author
    }), !isMobile && emphasisOnOwner && isNotOwner && /*#__PURE__*/ React.createElement(AuthorWatchButton, {
        className: s['watch-button'],
        author: owner
    }), isMlt && /*#__PURE__*/ React.createElement(IconButton, {
        className: s['mlt-button'],
        size: "medium",
        icon: MltSearch,
        href: Url.moreLikeThisLink(deviation.deviationId),
        biData: BiData({
            evid: 126,
            typeid: resourceType,
            itemid: deviation.deviationId,
            creatorid: (_deviation_author_useridUuid = (_deviation_author2 = deviation.author) === null || _deviation_author2 === void 0 ? void 0 : _deviation_author2.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
            sectionname: BiContextProvidedValue
        })
    })), children));
};
SidebarBlockWrapper.displayName = 'SidebarBlockWrapper';
export default SidebarBlockWrapper;

//# sourceMappingURL=SidebarBlockWrapper.js.map